import React from "react"
import PropTypes from "prop-types"
import { Link, Redirect } from "react-router-dom"

import { formatRoute } from "../../helpers/sharedHelperFunctions"
import Loading from "../Loading"
import routes from "../../routes"
import "./LandingPage.scss"

import { LandingPage as LandingPageComponent } from "@swipesense/landing-page"

class LandingPage extends React.Component {
  render() {
    return this.props.loading ? (
      <Loading />
    ) : this.props.facilities.length === 1 ? (
      <Redirect
        to={formatRoute(routes.facility, {
          facilityId: this.props.facilities[0].id,
        })}
      />
    ) : (
      <div>
        <div className="PageBanner">
          <h1>Your Facilities</h1>
        </div>
        <LandingPageComponent
          linkTag={Link}
          entities={this.props.facilities.map(facility => ({
            id: facility.id,
            imageUrl: "/icons/at_facility.svg",
            name: facility.name,
            departments: facility.departments,
            units: facility.units,
            link: formatRoute(
              formatRoute(routes.facility, { facilityId: facility.id })
            ),
          }))}
        />
      </div>
    )
  }
}

LandingPage.propTypes = {
  loading: PropTypes.bool,
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      departments: PropTypes.number,
      units: PropTypes.number,
    }).isRequired
  ),
}

export default LandingPage
